<template>
  <div class="card p-3 container-card--preview">
    <div class="card-body p-3 bg-white">
      <div class="row justify-content-center">
        <div v-if="selectedHome" class="card-item col-12 col-sm-5 col-md-4 col-lg-4 mr-1">
          <div class="badge-container">
            <template v-if="freeShippingHome">
              <span class="badge-free" :style="badgeStyle">Gratis</span>
            </template>
          </div>
          <div class="card-section">
            <div class="icon-container">
              <slot name="icon">
                <TiendaIcon />
              </slot>
            </div>
            <div class="item-section">
              <div class="item-label-title">Retiro en tienda</div>
            </div>
          </div>
        </div>

        <div v-if="selectedPudo" class="card-item col-12 col-sm-5 col-md-4 col-lg-4 mr-1">
          <div class="badge-container">
            <template v-if="freeShippingPudo">
              <span class="badge-free" :style="badgeStyle">Gratis</span>
            </template>
          </div>
          <div class="card-section">
            <div class="icon-container">
              <slot name="icon">
                <SucursalIcon />
              </slot>
            </div>
            <div class="item-section">
              <div class="item-label-title">Retiro en punto</div>
              <div class="item-label-caption">[Sucursal Courier]</div>
            </div>
          </div>
        </div>

        <div v-if="selectedDelivery" class="card-item col-12 col-sm-5 col-md-4 col-lg-4">
          <div class="badge-container">
            <template v-if="freeShippingDomicilio">
              <span class="badge-free" :style="badgeStyle">Gratis</span>
            </template>
          </div>
          <div class="card-section">
            <div class="icon-container">
              <slot name="icon">
                <DomicilioIcon />
              </slot>
            </div>
            <div class="item-section">
              <div class="item-label-title">Despacho a domicilio</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TiendaIcon from '@/Icons/TiendaIcon.vue'
import SucursalIcon from '@/Icons/SucursalIcon.vue'
import DomicilioIcon from '@/Icons/DomicilioIcon.vue'
export default {
  name: 'TabDelivery',
  props: {
    selectedHome: { type: Boolean, default: false },
    selectedPudo: { type: Boolean, default: false },
    selectedDelivery: { type: Boolean, default: true },
    freeShippingHome: { type: Boolean, default: false },
    freeShippingPudo: { type: Boolean, default: false },
    freeShippingDomicilio: { type: Boolean, default: false },
    badgesColor: { type: String, default: 'dark' }
  },
  components: {
    TiendaIcon,
    SucursalIcon,
    DomicilioIcon
  },
  computed: {
    badgeStyle() {
      return {
        backgroundColor: this.badgesColor || '#B0B0B0'
      }
    }
  }
}
</script>
<style scoped>
.container-card--preview {
  background-color: #F2F4F4;
  height: 500px;
  width: 700px;
  max-width: 700px;
}

.card-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #F5F9FA;
  border: 1px solid #DDE0E4;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 24px 16px;
  min-width: 160px;
  max-width: 175px;
  height: 200px;
}

.card-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.badge-container {
  position: absolute;
  top: 10px;
  right: 10px;
}

.badge-free {
  display: inline-block;
  color: #ffffff;
  border-radius: 24px;
  padding: 4px 14px;
  font-size: 12px;
}

.card-section {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-container img {
  max-width: 48px;
  height: auto;
}

.item-label-title {
  font-weight: 600;
  margin-bottom: 4px;
  color: #5E5873;
}

.item-label-caption {
  font-weight: 300;
  color: #6E6B7B;
  font-size: 10px;
}
</style>